
  import React from "react"
  import Component from "/home/glennsl/dev/remote/redex/redex.github.io/src/layouts/index.js"
  import data from "/home/glennsl/dev/remote/redex/redex.github.io/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js